module.exports = __webpack_public_path__ + "img/supporto_auto.503351c3.png";